import { mfaOptionsValues } from './constants'

export const isAValidDuration = duration => {
  if (!`${duration}`?.length) {
    return {
      isValid: false,
      error: 'Duration cannot be empty.',
    }
  }

  if (duration < 15) {
    return {
      isValid: false,
      error: 'Duration must be greater than or equal to 15',
    }
  }

  if (duration > 60) {
    return {
      isValid: false,
      error: 'Duration must be less than or equal to 60',
    }
  }

  return {
    isValid: true,
    error: '',
  }
}

export const isMfaOptionEnabled = (mfaFactorsList = [], factor) => {
  const factorData = mfaFactorsList.find(mfaFactor => mfaFactor.factor === factor)

  return factorData?.usable === mfaOptionsValues.ALLOWED
}
